import { Injectable } from "@angular/core";
import { MenuApiService } from "../administracion/configuracion/menus/service/menu-api.service";
import { BehaviorSubject } from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class PermisosService {

  private currentMenuId: number | null = null;

  private privilegiosSubject = new BehaviorSubject<any[]>([]);
  privilegios$ = this.privilegiosSubject.asObservable();


  constructor(private menuApiService: MenuApiService) {}

  cargarPrivilegios(menuId: number): Promise<void> {

    if(this.currentMenuId == menuId) {
      return Promise.resolve();
    }

    const raw = localStorage.getItem('rolesAsignados');

    if (!raw) {
      return Promise.resolve();
    };

    const roles = JSON.parse(raw).map((item: any) => item.id);

    const request = {
      roles: [roles],
      menuId: menuId
    }


    return new Promise<void>((resolve, reject) => {
      this.menuApiService.getAccionesByMenuAndRole(request).subscribe({
        next: (data) => {
          this.currentMenuId = menuId;
          this.privilegiosSubject.next(data);
          resolve()
        },
        error: (err)=> {
          this.currentMenuId = null;
          this.privilegiosSubject.next([]);
          reject()
        }
      })
    });

  }

  limpiarPrivilegios(): void {
    this.privilegiosSubject.next([]);
    this.currentMenuId = null;
  }

  getPrivilegios(): any[] {
    return this.privilegiosSubject.getValue();
  }
}